import { Alert } from "@mui/material";
import { isDemoMode } from "@/shared/config/demoMode";
import { CompactChromeRow } from "@/shared/ui/mobileChrome";
import { useCompactLayout } from "@/shared/ui/useCompactLayout";
import { APP_HEADER_HEIGHT_PX, chromeRemaining } from "@/shared/ui/compactChrome/chromeCss";
import { systemBannerSx } from "@/shared/ui/systemBannerStyles";

/**
 * App-wide banner shown while demo mode is active, so the SystemAdmin always knows the
 * session is showing synthetic, read-only data. Toggled via the account menu.
 */
export default function DemoModeBanner() {
  const compact = useCompactLayout();
  if (!isDemoMode()) {
    return null;
  }

  return (
    <CompactChromeRow>
      <Alert
        severity="warning"
        square
        sx={(theme) => ({
          ...systemBannerSx,
          flexShrink: 0,
          ...(compact
            ? {
                position: "sticky",
                top: chromeRemaining(APP_HEADER_HEIGHT_PX),
                zIndex: theme.zIndex.appBar,
              }
            : {}),
        })}
      >
        Demo mode — showing synthetic sample data (read-only). No real firm data is displayed.
      </Alert>
    </CompactChromeRow>
  );
}
